import REQUEST_ROUTES from '@/presentation/modules/request/constants/routes/index.js';

const requestRoutes = [
	{
		name: REQUEST_ROUTES.requestRoot.name,
		path: REQUEST_ROUTES.requestRoot.path,
		redirect: REQUEST_ROUTES.requestRoot.redirect,
		meta: REQUEST_ROUTES.requestRoot.meta,
		component: REQUEST_ROUTES.requestRoot.component,
		children: [
			{
				name: REQUEST_ROUTES.request.name,
				path: REQUEST_ROUTES.request.path,
				meta: REQUEST_ROUTES.request.meta,
				component: REQUEST_ROUTES.request.component,
			},
		],
	},
];

export default requestRoutes;
